/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useMemo, type FunctionComponent } from 'react';
import { Check, Info, Times } from '../../../Icon';
import { Perk } from '../interfaces';
import * as styles from './PerkItem.module.scss';

export type PerkItemProps = Pick<Perk, 'perk' | 'included' | 'tooltip'>;

const PerkItem: FunctionComponent<PerkItemProps> = ({ perk, included, tooltip = '' }) => {
  const tooltipStyles = useMemo(() => {
    if (tooltip.length && tooltip.length < 75) {
      return `${styles.plansTooltip} ${styles.plansTooltipShort}`;
    }

    return styles.plansTooltip;
  }, [tooltip.length]);

  const perkIcon = included ? (
    <Check data-testid="check-icon" />
  ) : (
    <Times data-testid="times-icon" />
  );

  return (
    <li className={`${included ? '' : styles.perkExcluded} ${styles.perk}`}>
      <span className={styles.perkIcon}>{perkIcon}</span>
      <div className={styles.perkText}>
        <p>
          {perk}
          {tooltip && (
            // TODO: Please fix the a11y issues with this element and then remove the comments at the top of the file.
            <span
              onClick={(e) => e.stopPropagation()}
              className={tooltipStyles}
              data-tooltip={tooltip}
            >
              <Info fill="#CCCCCC" />
            </span>
          )}
        </p>
      </div>
    </li>
  );
};

export default PerkItem;
